<template>
  <div class="employees-vibe-wrap">
    <div class="vibe-cards-wrap">
      <div class="vibe-title">Employees’ vibe
        <div class="info-icon pt-5" name="Engagement3" style="display: initial;">
          <i class="las la-info-circle ls-4"></i>
        </div>
        <tippy to="Engagement3"
          interactive="true"
          theme="light amara"
          class="am-tool"
          :allowHTML="true"
          arrow
          placement="right"
        >
          <h3 class="am-card-title pr-1"><b>Employees’ vibe</b></h3>
          <p>
            Get a bird’s eye view of the mood of your
  employees towards the company, across any demography.
          </p>
        </tippy>
      </div>
      <div class="vibe-body" v-if="report && report.length > 0">
        <v-row class="vibe-list" no-gutters
          v-for="(r, idx) in report"
          :key="idx"
        >
          <v-col cols="1">
            <div class="vibe-mood">
              <img :src='getImgUrl(r.mood)' height="40" width="40">
            </div>
          </v-col>
          <v-col cols="11" class="pl-2">
            <v-row no-gutters>
              <v-col cols="9">
                <div class="vibe-progress">
                  <v-row no-gutters>
                    <v-col class="vibe-score text-left">{{r.value}}&nbsp;&nbsp;
                      <span v-if="dashboardData.company_mood_breakdown_percentage && dashboardData.company_mood_breakdown_percentage[r.mood]">
                        ({{dashboardData.company_mood_breakdown_percentage[r.mood]}}%)
                      </span>
                      <span v-else>(0%)</span>
                    </v-col>
                    <v-col class="vibe-text text-right">{{getName(r.mood)}}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="vibe-linear">
                      <v-progress-linear
                        :active="true"
                        :background-opacity="0.3"
                        :bottom="false"
                        :buffer-value="100"
                        :height="4"
                        :indeterminate="false"
                        :query="false"
                        :rounded="true"
                        :stream="false"
                        :striped="false"
                        :top="false"
                        :value="dashboardData.company_mood_breakdown_percentage[r.mood]"
                        :color="getSeriesColor(r.mood)"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="vibe-action">
                  <v-btn class="pa-2" small outlined @click="viewEmployees(r.mood)">View Details</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div class="vibe-body am-no-data" v-else>
        {{noDataText}}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OverviewMixin from './overview-mixin';

export default {
  name: 'EmployeesVibe',

  mixins: [OverviewMixin],

  data () {
    return {
      report: []
    };
  },

  mounted () {
    this.initVibeData();
    console.log(this.updateDashboardFilters.user__profile__high_potential_emp);
  },

  watch: {
    dashboardData: {
      deep: true,
      handler () {
        this.initVibeData();
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.dashboardFilters,
      updateDashboardFilters: state => state.updateDashboardFilters
    })
  },
  methods: {
    viewEmployees (mood) {
      const employeeFilters = {
        mood__in: mood || undefined,
        ...this.updateDashboardFilters
      };
      if (this.$route.query && this.$route.query.stage) {
        employeeFilters.user_session__stage__title = this.$route.query.stage;
      }
      this.$store.dispatch('updateEmployeeFilters', employeeFilters);
      this.$nextTick(() => {
        this.$router.push({
          path: '/employees',
          query: {
            filters: JSON.stringify(employeeFilters)
          }
        }).catch(() => {});
      });
    },
    initVibeData () {
      this.report = [];
      if (this.dashboardData.company_mood_breakdown) {
        const temp = ['1', '2', '3', '4', '5'];
        // this.$lodash.each(this.dashboardData.company_mood_breakdown, (val, key) => {
        this.$lodash.each(temp, (val) => {
          const t = {};
          t.mood = val;
          t.value = this.dashboardData.company_mood_breakdown && this.dashboardData.company_mood_breakdown[val] ? this.dashboardData.company_mood_breakdown[val] : 0;
          this.report.push(t);
        });
      }
    },
    getSeriesColor (pet) {
      let color = '#84b761';
      if (pet === '5') {
        color = '#62be71';
      } else if (pet === '4') {
        color = '#a1ce6a';
      } else if (pet === '3') {
        color = '#f5ab52';
      } else if (pet === '2') {
        color = '#f0724b';
      } else if (pet === '1') {
        color = '#ee5d4b';
      }
      return color;
    },
    getImgUrl (pet) {
      if (pet) {
        const images = require.context('@/assets/', false, /\.png$/);
        return images(`./${pet}.png`);
      }
    },
    getName (pet) {
      let mood = '';
      if (pet === '5') {
        mood = 'Awesome';
      } else if (pet === '4') {
        mood = 'Good';
      } else if (pet === '3') {
        mood = 'Okay';
      } else if (pet === '2') {
        mood = 'Disappointed';
      } else if (pet === '1') {
        mood = 'Terrible';
      }
      return mood;
    }
  }
};
</script>

<style lang="scss" scoped>
.employees-vibe-wrap {
  background-color: var(--bg);
  padding: 16px;
  border-radius: 6px;
  // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
  box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
  height: 26rem;
  .am-no-data {
    height: 20rem;
  }
  .vibe-title {
    font-size: var(--content-size);
    font-size: 20px;
    color: var(--color-text);
    padding: 8px 0;
  }
  .vibe-body {
    .vibe-list {
      padding: 8px 0;
      .vibe-progress {
        padding: 0 8px;
      }
    }
  }
}
</style>
